export const MODAL_NAME = "addProjectSpecialNoteModal";
